import Checkbox from "@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox";
import { FacetComponentProps } from "../../FacetItem";
import { slugify } from "@/utils/slugify";

export const CheckboxFacet = ({
  facetDetails: { isSelected, facetUrl, label, qty },
  disabled,
  facetName,
}: FacetComponentProps) => (
  <Checkbox
    ariaLabel={label}
    checked={isSelected === "true"}
    disabled={disabled}
    id={slugify(facetUrl || "")}
    isControlled
    isRealFormControl={false}
    label={`${label} (${qty})`}
    name={slugify(facetName + label)}
    data-testid="checkbox-facet"
  />
);
